import { getWebsite, getWebsiteSection, postContact } from 'website/website.service.js';
export const types = {
  "FETCH_WEBSITE"         : "FETCH_WEBSITE",
  "FETCH_WEBSITE_REQUEST" : "FETCH_WEBSITE_REQUEST",
  "FETCH_WEBSITE_SUCCESS" : "FETCH_WEBSITE_SUCCESS",
  "FETCH_WEBSITE_SECTION" : "FETCH_WEBSITE_SECTION",
  "SUBMIT_CONTACT"        : "SUBMIT_CONTACT",
  "UI_ACTION"             : "UI_ACTION"
};

const websiteAction = (website) => ({
  type: types.FETCH_WEBSITE,
  website
});

const websiteRequestAction = () => ({
  type: types.FETCH_WEBSITE_REQUEST
});

const websiteCompleteAction = () => ({
  type: types.FETCH_WEBSITE_SUCCESS
});

const websiteSectionAction = (sectionType, sectionData) => ({
  type: types.FETCH_WEBSITE_SECTION,
  sectionType,
  sectionData
});

const contactSubmitAction = (result) => ({
  type: types.SUBMIT_CONTACT,
  result
});

export const uiAction = (data) => ({
  type: types.UI_ACTION,
  data
});

function fetchWebsiteSections() {
  return (dispatch, getState) => {
    return Promise.all(getState().website.sections.map(section => {
      return getWebsiteSection(section.type)
        .then(sectionData => {
          return dispatch(websiteSectionAction(section.type, sectionData))
        });
    }));
  }
}

export function fetchWebsite() {
  return (dispatch) => {
    dispatch(websiteRequestAction());

    return getWebsite()
      .then(website => {
        return dispatch(websiteAction(website));
      })
      .then(() => dispatch(fetchWebsiteSections()))
      .then(() => dispatch(websiteCompleteAction()));
  };
}

export const contactSubmit = data => dispatch => postContact(data)
  .then(result => dispatch(contactSubmitAction(result)))
  .catch(err => dispatch(contactSubmitAction({ err })));


// WEBPACK FOOTER //
// ./src/website/website.actions.js